import { useContext } from 'react'
import { AuthContext } from './auth_context'

export function useAuth() {
    return useContext(AuthContext)
}